
import { LocalData } from "../../../General/LocalData";
import { NotificationData } from "../NotificationData";
import { t } from "i18next";

export class NotificationNewDeviationData extends NotificationData {
  propertyID: string = "";
  deviationID: string = "";
  authorID: string = "";
  authorName: string = "";
  propertyName: string = "";

  setup(data: any) {
    super.setup(data)
    this.type = NotificationData.types.NEW_DEVIATION;
    
    if(data.notificationData){
      this.propertyID = data.notificationData?.propertyID ?? "";
      this.propertyName = data.notificationData?.propertyName ?? "";
      this.deviationID = data.notificationData?.deviationID ?? "";
      this.authorID = data.notificationData?.authorID ?? "";
      this.authorName = data.notificationData?.authorName ?? "";
      
      this.title = data.notificationData?.title;
      this.body = `${this.authorName} ${t('main.deviationNotification_reportedDeviationOn')} ${this.propertyName}`;
      this.userForImageView = LocalData.users.addData(this.authorID);
      this.redirectPath = `/properties/${this.propertyID}/tasks/${this.deviationID}`;
    }
  }
}